module.exports = __webpack_public_path__ + "src/assets/images/login/customers/Wilmar_logo.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/customers/Wilmar_logo.jpg
// module id = 2315
// module chunks = 4